/* Barklie mobiel menu: openen/sluiten, Escape, focus binnen het paneel houden. */
if (!customElements.get('bk-menu-drawer')) {
  customElements.define(
    'bk-menu-drawer',
    class BkMenuDrawer extends HTMLElement {
      connectedCallback() {
        this.openButton = this.querySelector('.bk-menu__open');
        this.panel = this.querySelector('.bk-menu__panel');
        this.closeButton = this.querySelector('.bk-menu__close');

        this.openButton.addEventListener('click', () => this.open());
        this.closeButton.addEventListener('click', () => this.close());
        this.panel.addEventListener('keydown', (event) => this.onKeydown(event));
      }

      open() {
        this.panel.inert = false;
        this.panel.classList.add('is-open');
        this.openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('bk-menu-open');
        requestAnimationFrame(() => this.closeButton.focus());
      }

      close() {
        this.panel.classList.remove('is-open');
        this.panel.inert = true;
        this.openButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('bk-menu-open');
        this.openButton.focus();
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = [...this.panel.querySelectorAll('a[href], button, summary')].filter(
          (element) => element.offsetParent !== null
        );
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  );
}

/* Homepage: header doorzichtig over de hero, daaronder navy. Dawn zet 'scrolled-past-header' alleen
   bij een scroll-event; na een sprong (anker, herladen halverwege, tabblad op de achtergrond) bleef
   de header soms doorzichtig. Daarom zelf de positie controleren en 'bk-solid' zetten (zelfde drempel
   als Dawn: onderkant van de header). */
(function () {
  var header = document.querySelector('.section-header');
  if (!header) return;
  var ticking = false;
  function check() {
    ticking = false;
    /* plakkende header: offsetTop is de huidige plek, dus de oorspronkelijke onderkant optellen
       uit de secties erboven (aankondigingsbalk) + de header zelf */
    var limit = header.offsetHeight, el = header.previousElementSibling;
    while (el) { if (el.classList.contains('shopify-section')) limit += el.offsetHeight; el = el.previousElementSibling; }
    header.classList.toggle('bk-solid', window.scrollY > limit);
  }
  function queue() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(check);
  }
  window.addEventListener('scroll', queue, { passive: true });
  ['load', 'pageshow', 'hashchange', 'resize'].forEach(function (ev) { window.addEventListener(ev, check); });
  document.addEventListener('visibilitychange', check);
  check();
})();
